/** Ícones próprios de dados poliédricos para a fileira de dados rápidos. */

const SHAPES: Record<number, string> = {
  4: 'M12 3 21 19H3Z M12 3v16',
  6: 'M12 2.5 20.5 7v10L12 21.5 3.5 17V7Z M3.5 7 12 11.5 20.5 7 M12 11.5v10',
  8: 'M12 2 21 12 12 22 3 12Z M3 12h18',
  10: 'M12 2 21 10.5 12 22 3 10.5Z M3 10.5l9 3.5 9-3.5 M12 14v8',
  12: 'M12 2.5 21 9l-3.4 10.5H6.4L3 9Z M12 7l4.5 3.3-1.7 5.2H9.2L7.5 10.3Z',
  20: 'M12 2 20.5 7v10L12 22 3.5 17V7Z M12 7.5 16.5 15h-9Z M12 2v5.5 M3.5 7l4 8 M20.5 7l-4 8',
};

export function DieIcon({ sides, size = 18 }: { sides: number; size?: number }) {
  if (sides === 100) {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M8 16 16 8" strokeLinecap="round" />
        <circle cx="8.5" cy="8.5" r="1.4" />
        <circle cx="15.5" cy="15.5" r="1.4" />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" aria-hidden="true">
      <path d={SHAPES[sides] ?? SHAPES[20]!} />
    </svg>
  );
}
